__turbopack_context__.v({
  "bottom": "drawer-module-scss-module__Fqc6hG__bottom",
  "content": "drawer-module-scss-module__Fqc6hG__content",
  "description": "drawer-module-scss-module__Fqc6hG__description",
  "error-msg": "drawer-module-scss-module__Fqc6hG__error-msg",
  "errorIcon": "drawer-module-scss-module__Fqc6hG__errorIcon",
  "footer": "drawer-module-scss-module__Fqc6hG__footer",
  "handle": "drawer-module-scss-module__Fqc6hG__handle",
  "header": "drawer-module-scss-module__Fqc6hG__header",
  "hint": "drawer-module-scss-module__Fqc6hG__hint",
  "left": "drawer-module-scss-module__Fqc6hG__left",
  "overlay": "drawer-module-scss-module__Fqc6hG__overlay",
  "right": "drawer-module-scss-module__Fqc6hG__right",
  "title": "drawer-module-scss-module__Fqc6hG__title",
  "trigger": "drawer-module-scss-module__Fqc6hG__trigger",
});
